import React from "react";
import { usePageTitle } from "../hooks/usePageTitle";

const Cookies = () => {
  usePageTitle("Cookie Policy");

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-white mb-6">Cookie Policy</h1>
      <p className="text-gray-400 text-sm mb-8">
        Last updated: February 18, 2026
      </p>

      <div className="space-y-8 text-gray-300">
        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            1. What Are Cookies?
          </h2>
          <p>
            Cookies are small text files stored on your device when you visit a
            website. They help websites remember your preferences and improve
            your experience.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            2. Cookies We Use
          </h2>

          <div className="mt-4">
            <h3 className="text-xl font-semibold text-white mb-2">
              Essential Cookies (Required)
            </h3>
            <p className="mb-2">
              These cookies are necessary for the website to function:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>
                <strong>Authentication Token:</strong> Keeps you logged in
              </li>
              <li>
                <strong>Cookie Consent:</strong> Remembers your cookie
                preferences
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h3 className="text-xl font-semibold text-white mb-2">
              Functional Cookies (Optional)
            </h3>
            <p className="mb-2">These cookies enhance your experience:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>
                <strong>User Preferences:</strong> Remembers your display
                settings
              </li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            3. Third-Party Cookies
          </h2>
          <p>
            We do not currently use third-party cookies for analytics or
            advertising. If this changes, we will update this policy and notify
            you.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            4. Managing Cookies
          </h2>
          <p className="mb-3">You can control cookies through:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              <strong>Browser Settings:</strong> Most browsers allow you to
              refuse cookies
            </li>
            <li>
              <strong>Our Cookie Banner:</strong> Accept or decline optional
              cookies
            </li>
          </ul>
          <p className="mt-3">
            Note: Blocking essential cookies may prevent you from using certain
            features of the site, such as staying logged in.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            5. Cookie Duration
          </h2>
          <p className="mb-3">We use both session and persistent cookies:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              <strong>Session Cookies:</strong> Deleted when you close your
              browser
            </li>
            <li>
              <strong>Persistent Cookies:</strong> Remain until expiration or
              manual deletion
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            6. Updates to This Policy
          </h2>
          <p>
            We may update this cookie policy to reflect changes in technology or
            legal requirements. Check this page periodically for updates.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            7. Contact Us
          </h2>
          <p>
            Questions about our use of cookies? Contact us at:{" "}
            <a
              href="mailto:privacy@collectarena.com"
              className="text-blue-400 hover:text-blue-300"
            >
              privacy@collectarena.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Cookies;
